import { Card } from "react-bootstrap";
import type { BlogPost } from '~/models/blogPost';

interface Props {
    post: BlogPost;
}

export default function BlogCard({ post }: Props) {
    const excerpt = post.excerpt || '';
    const textLen = 175;
    const shortExcerpt = excerpt.substring(0, textLen) + (excerpt.length > textLen ? '...' : '');
    
    // Format the published date
    const publishedDate = new Date(post.published_at).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });

    return (
        <Card className="course-item h-100">
            {post.feature_image && (
                <Card.Img 
                    variant="top" 
                    src={post.feature_image} 
                    alt={post.title}
                    style={{ objectFit: 'cover', height: '200px' }}
                />
            )}
            <Card.Body className="course-content d-flex flex-column">
                <Card.Title as="div" className="d-flex justify-content-between align-items-center mb-2">
                    <small className="text-muted">
                        <i className="bi bi-calendar-event me-1"></i>
                        {publishedDate}
                    </small>
                    {post.reading_time && (
                        <small className="text-muted">
                            <i className="bi bi-clock me-1"></i>
                            {post.reading_time} min read
                        </small>
                    )}
                </Card.Title>

                <Card.Title as="h3" className="mb-3">{post.title}</Card.Title>
                <Card.Text className="flex-grow-1">
                    {shortExcerpt}
                </Card.Text>
            </Card.Body>
            <Card.Footer className="trainer d-flex justify-content-between align-items-center">
                <a 
                    href={post.url}
                    className="btn btn-primary"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Read More
                </a>
            </Card.Footer>
        </Card>
    );
}
